import React from 'react';
import { Mail } from 'lucide-react';
import { aggregateTaxEmailStatus, taxEmailTooltip } from '../../lib/taxEmailStatus';

// TAX-EMAIL-RECEIVED-001 — sits beside FaxIndicator; same gray → blue → green semantics, Mail glyph so the
// channel awaiting a response is unambiguous. Partial receipt stays gray with a count tooltip.
const COLORS = { sent: '#9CA3AF', partial: '#9CA3AF', received: '#3B82F6', reviewed: '#22C55E' };

export const EmailIndicator = ({ taxEmailStatus, taxEmailRequests }) => {
  const agg = aggregateTaxEmailStatus(taxEmailStatus, taxEmailRequests);
  if (!agg.state || !COLORS[agg.state]) return null;
  return (
    <span
      className="inline-flex items-center ml-1"
      title={taxEmailTooltip(agg)}
      data-testid={`email-indicator-${agg.state}`}
      data-received={agg.received}
      data-total={agg.total}
    >
      <Mail size={14} color={COLORS[agg.state]} strokeWidth={2} />
    </span>
  );
};

export default EmailIndicator;
